import { ErrorOutline, AccessTime, Phone, ArrowForward, Voicemail, Email } from "@mui/icons-material";
import { Button, CircularProgress } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatTimestamp, formatTime, formatTimestampForZone } from '../utils/formattimestamp';
import { formatPhoneNumber } from '../utils/formatnumber';
import ChangeOrgModalNew from "../modals/ChangeOrgModalNew";
import AudioPlayer from "../utils/AudioPlayer";

const CallDetails = ({conversation}) => {
  const [err_msg, setErrorMsg] = useState(null);
  const navigate = useNavigate()
  const [route, setRoute] = useState({
    route_name: 'N/A'
  })
  const [loader, setLoader] = useState(false);
  const [call, setCall] = useState(null);

  const {call_id} = useParams()





  const getRoute = async () => {
    //alert(call?.route)
      try {
        let route = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "route/get-route",
          { route_id:  call?.route}
        );

        console.log(route);

        setLoader(false);



        let r = route?.data.route;

        console.log({ r });

        setRoute({
          route_id: r.routeId,
          route_name: r.name,
          configured_phone: r.configured_phone,
          organization_id: r.org_id,
          early_time: r.earlyTime,
          late_time: r.lateTime,
          primary_action: r.primaryAction,
          recording_id: r.primaryRecording,
          primary_number: r.primaryNumber,
          off_hours_number: r.offHoursNumber,
          primary_channel: r.primaryChannel,
          off_hours_action: r.offHoursAction,
          off_hours_recording: r.offHoursRecording,
          off_hours_number: r.offHoursNumber,
          off_hours_channel: r.offHoursChannel,
          active_friday: r.calendar.fri.BOOL,
          active_monday: r.calendar.mon.BOOL,
          active_saturday: r.calendar.sat.BOOL,
          active_sunday: r.calendar.sun.BOOL,
          active_thursday: r.calendar.thur.BOOL,
          active_tuesday: r.calendar.tue.BOOL,
          active_wednesday: r.calendar.wed.BOOL,
        });


      } catch (error) {
        console.log(error);
        if (error.response && error.response.data) {
          console.error("Response data:", error.response.data);
          if(error.response.data.message === `Route with route_id ${call?.route} not found`){
            setRoute({...route, route_name: 'Deleted Route', route_id : 'deleted'})
          }else{
            setErrorMsg(error.response.data.message)
          }

        }
        setLoader(false);
      }
    };

  const getCall = async () => {
    setLoader(true);
    try {
      let call_ = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "call/get-call",
        {
          call_id,
          organization_id: JSON.parse(localStorage.getItem('organization')).orgId.S,
        }
      );
      let call__ = call_.data.call;

      console.log(call__)


      setCall(call__);

      setLoader(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        if(error.response.data.message === '001'){
          setChangeOrg(true)
        }else{
          setErrorMsg(
            error.response.data.error + " " + error.response.data?.message
          );

        }
      }
      setLoader(false);
    }
  };




  useEffect(() => {
    getCall();
  }, [conversation]);

  const [change_org , setChangeOrg] = useState(false)
  useEffect(() => {

    if(call?.route){
      console.log(call)
      getRoute()
    }
    if(call){
      if(call.organizationId !== JSON.parse(localStorage.getItem("organization")).orgId.S){
        setChangeOrg(false)
      }
    }
  }, [call]);

  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')))
         const [orgs, setOrgs] = useState()

          const getAllOrgs = async () => {
             setLoader(true)
               let orgs = await axios.post(
                 process.env.REACT_APP_BACKEND_URL + "get-organizations",
                 {
                     userId: JSON.parse(localStorage.getItem('user')).userId.S
                 }
               );
               console.log('orgs',orgs)
               setOrgs(orgs.data)
               setLoader(false)
             }
    useEffect(() => {
      getAllOrgs()

    }, []);


    const changeOrganization = async (org_id) => {
        try {
          let org = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "get-organization",
            { orgId: org_id }
          );
          localStorage.setItem(
            "organization",
            JSON.stringify(org.data.organization)
          );

          window.location.reload()
        } catch (error) {
          console.log(error);
          if (error.response && error.response.data) {
            console.error("Response data:", error.response.data);
            setErrorMsg(error.response.data.message);
          }
          setLoader(false);
        }
      };




  return (
    <div className="pt-7 px-2 sm:px-4">
      {/* <ChangeOrgModalNew open={change_org} setOpen={setChangeOrg} /> */}
      <div className="lg:text-[24px] text-[18px] font-bold mb-2">Call Details</div>
      <div className="text-gray-500 text-[13px] mb-4">Call ID: {call_id}</div>

      {err_msg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold mb-3">
          <ErrorOutline sx={{ fontSize: "" }} /> {err_msg}
        </div>
      )}

      {loader && <CircularProgress size={"1.2rem"} sx={{ color: "#605BFF", animationDuration: "0.7s", }} />}

      {!change_org ? (
        <div className="bg-white rounded-[13px] w-full my-5 p-4 sm:p-8 shadow-sm">
          {/* Call Information Section */}
          <div className="mb-6">
            <div className="text-[18px] font-semibold mb-4">Call Information</div>
            <div className="space-y-3">
              <div className="flex items-center text-[15px]">
                <AccessTime className="mr-2 text-gray-500" fontSize="small" />
                <span className="font-medium text-gray-600 w-28">Time</span>
                <span className="ml-2">{call && call.startTime ? `${formatTimestampForZone(call?.startTime)}` : "N/A"}</span>
              </div>
              <div className="flex items-center text-[15px]">
                <Phone className="mr-2 text-gray-500" fontSize="small" />
                <span className="font-medium text-gray-600 w-28">To Number</span>
                <span className="ml-2">{formatPhoneNumber(call?.toNumber) || "N/A"}</span>
              </div>
              <div className="flex items-center text-[15px]">
                <ArrowForward className="mr-2 text-gray-500" fontSize="small" />
                <span className="font-medium text-gray-600 w-28">Route</span>
                <span className="ml-2 hover:underline cursor-pointer hover:text-blue-700"
                  onClick={() => { navigate('/dashboard/call-route/' + call?.route) }}>
                  {route?.route_name || "N/A"}
                </span>
              </div>
              <div className="flex items-center text-[15px]">
                <Phone className="mr-2 text-gray-500" fontSize="small" />
                <span className="font-medium text-gray-600 w-28">From</span>
                <span className="ml-2">{formatPhoneNumber(call?.fromNumber) || "N/A"}</span>
              </div>
              {call?.duration && (
                <div className="flex items-center text-[15px]">
                  <AccessTime className="mr-2 text-gray-500" fontSize="small" />
                  <span className="font-medium text-gray-600 w-28">Duration</span>
                  <span className="ml-2">{call.duration}</span>
                </div>
              )}
            </div>
          </div>

          {/* Action Details Section */}
          <div className="mb-6">
            <div className="text-[18px] font-semibold mb-4">Action Details</div>
            <div className="space-y-3">
              <div className="flex items-center text-[15px]">
                <ArrowForward className="mr-2 text-gray-500" fontSize="small" />
                <span className="font-medium text-gray-600 w-28">Action</span>
                <span className="ml-2">{call?.action || "N/A"}</span>
              </div>
              <div className="flex items-center text-[15px]">
                <ArrowForward className="mr-2 text-gray-500" fontSize="small" />
                <span className="font-medium text-gray-600 w-28">Action Details</span>
                <span className="ml-2">{call?.action_details || "N/A"}</span>
              </div>
              <div className="flex items-center text-[15px]">
                <Email className="mr-2 text-gray-500" fontSize="small" />
                <span className="font-medium text-gray-600 w-28">Notification</span>
                <span className="ml-2">{call?.notification || "N/A"}</span>
              </div>
              <div className="flex items-center text-[15px]">
                <Email className="mr-2 text-gray-500" fontSize="small" />
                <span className="font-medium text-gray-600 w-28">Notification Details</span>
                <span className="ml-2">{call?.notificationDetails || "N/A"}</span>
              </div>
            </div>
          </div>

          {/* Voicemail Section */}
          <div className="mb-2">
            <div className="text-[18px] font-semibold mb-4 flex items-center">
              <Voicemail className="mr-2 text-gray-500" fontSize="medium" />
              Voicemail
            </div>
            {call?.s3Object !== 'htp' && call?.s3Object?.length > 1 ? (
              <AudioPlayer url={call?.s3Object} />
            ) : (
              <div className="text-[15px] text-gray-500 bg-gray-50 rounded-lg p-4">This call does not have a voicemail</div>
            )}
            {/* Return Call Button */}
            {(call?.fromNumber || call?.toNumber) && (
              <div className="mt-4 flex justify-start">
                <Button
                  variant="contained"
                  startIcon={<img src="/icons/phone_white.png" className="w-[20px] h-[20px]" alt="Return Call" />}
                  onClick={() => {
                    const isOutbound = call?.action === 'Outbound Call';
                    const recipient = isOutbound ? call?.toNumber : call?.fromNumber;
                    navigate(`/dashboard/dialer?recipient=${encodeURIComponent(recipient)}`);
                  }}
                  sx={{
                    textTransform: 'none',
                    borderRadius: '7px',
                    fontSize: { lg: '17px', xs: '15px' },
                    px: { lg: '36px', xs: '20px' },
                    py: { lg: '4px', xs: '10px' },
                    boxShadow: 1,
                    width: { xs: '100%', sm: 'auto' },
                    backgroundColor: '#605bff',
                    ':hover': {
                      boxShadow: 3,
                      backgroundColor: '#4b47cc',
                    },
                  }}
                >
                  {call?.action === 'Outbound Call' ? 'Redial' : 'Return Call'}
                </Button>
              </div>
            )}
          </div>

          {/* Transcription Section (if available) */}
          {call?.has_vm && (
            <div className="mt-4">
              <div className="text-[16px] font-semibold mb-1">Transcription</div>
              <div className="text-[14px]">
                {call?.vmTranscription || (<div className="text-[11px]">Transcription unavailable</div>)}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="">
          <div className="lg:px-8 px-4 py-14 bg-white  w-fit">
            <div className="lg:text-[14px] text-[13px] text-center mb-2" >
              Oops! We couldn't find a record for call <span className="font-bold"> {call_id }</span> in <span className="font-bold">{JSON.parse(localStorage.getItem('organization'))?.organization_name?.S}</span>.
              Is it possible the URL is incorrect or that you mean to be logged in as a different organization?
              If you need help, please <a className="text-blue-800 hover:underline" href='mailto:hello@twilanswer.com'>Contact Support</a>.
            </div>

            <div className="flex items-center justify-center space-x-3 mt-4">
              {loader ? (
                <CircularProgress size={"1.0rem"} sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
              ) : (
                <div className="flex items-center justify-center space-x-3 mt-4">
                  <Button
                    sx={{
                      textTransform: "none",
                      bgcolor: "rgba(236,72,92,0.1)",
                      color: "rgba(236,72,92,1)",
                      py: "6px",
                      px: "30px",
                      borderRadius: "7px",
                      fontSize: { lg: "14px", xs: "13px" },
                      width: "fit",
                    }}
                    onClick={()=> {
                      localStorage.clear()
                      navigate('/login')
                    }}
                  >
                    Logout
                  </Button>

                  <Button
                    sx={{
                      textTransform: "none",
                      bgcolor: "#605BFF",
                      color: "white",
                      py: "6px",
                      px: "30px",
                      borderRadius: "7px",
                      fontSize: { lg: "14px", xs: "13px" },
                      width: "fit",
                    }}
                    onClick={()=> {
                      navigate('/dashboard/')
                    }}
                  >
                    Go to dashboard
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CallDetails;
